export type { FixedDocxDocument } from '@/modules/templates/components/docx-generate/docx-review/document-payload';
import {
  parseDocxDocument,
  type FixedDocxDocument,
} from '@/modules/templates/components/docx-generate/docx-review/document-payload';

/**
 * Parse a contract's `Document` JSON and return it only when it's a fixed-DOCX
 * document, e.g. `{"type":"fixed_docx","docxUrl":"…","docxFileId":"…"}`.
 * Returns `null` for any other type or when the string isn't valid JSON.
 *
 * Note this deliberately re-exports the single `FixedDocxDocument` definition
 * rather than declaring a second one — there used to be two divergent copies of
 * this shape, and only one of them knew about `docxUrl`.
 */
export const isFixedDocxContract = (doc?: string): FixedDocxDocument | null => {
  if (!doc || !doc.includes('fixed_docx')) return null;
  const parsed = parseDocxDocument(doc);
  return parsed?.type === 'fixed_docx' ? parsed : null;
};
